import React,{useState,useEffect} from 'react';
import ProjectCard from './Project_Card/Project_Card';
import "./Projects.css";
import "./Projects_Responsive.css";
import ReactLoading from 'react-loading';
import HMS_img from '../../assets/images/projects/HMS.png';
import CarTrack_img from '../../assets/images/projects/CarTrack.png';
import HousePro_img from '../../assets/images/projects/HousePro.png';
import Motion_img from '../../assets/images/projects/Motion.png';
import Onegivv_img from '../../assets/images/projects/Onegivv.png';
import Tourmed_img from '../../assets/images/projects/Tourmed.png';
import Tnant_img from '../../assets/images/projects/Tnant.png';
import Cubizy_img from '../../assets/images/projects/Cubizy.png';
import Hubbers_img from '../../assets/images/projects/hubbers.png'
import Hellofresh_img from '../../assets/images/projects/hellofresh.png'
import Madpaws_img from '../../assets/images/projects/madpaws.png'
import Beroomers_img from '../../assets/images/projects/beroomers.png'
import Loved_img from '../../assets/images/projects/loved.png'
import Boutique_img from '../../assets/images/projects/boutique.png'
import ChatApp_img from '../../assets/images/projects/ChatApp.png';
import FontPreview_img from '../../assets/images/projects/FontPreview.png'
import Autofill_img from '../../assets/images/projects/Autofill.png'

/*
//
//import EasyJet_img from '../../assets/images/projects/EasyJet.png';
//
        {
            name : "A responsive chat-app static pages",
            tags : ["CSS3", "mobile-responsive"],
            icon : ChatApp_img,
            link : "https://github.com/WillieRivera/Chat-App"
        },
                {
            name : "A journey management system using Python's bottle framework",
            tags : ["bottle-framework", "python", "googlemaps-api"],
            icon : EasyJet_img,
            link : "https://github.com/WillieRivera/EasyJet"
        },
        {
            name : "A font preview plugin with which you can add/remove/preview fonts",
            tags : ["wordpress-plugin", "font-preview"],
            icon : FontPreview_img,
            link : "https://github.com/WillieRivera/WordpressFontPreview"
        },
        
*/

export default function Projects()
{
    const [keyword, setKeyword] = useState("")

    const handleKeywordChange = e => {
        setKeyword(e.target.value)
    }

    const projects=[
        {
            name : "A non-profit website that is developed using MERN stack",
            tags : ["react", "redux-saga", "express", "sendgrid", "twillio"],
            icon : Onegivv_img,
            link : "https://onegivv.com"
        },
        {
            name : "Community platform for product creators using React",
            tags : ["react", "chart.js"],
            icon : Hubbers_img,
            link : "https://hubbers.io"
        },
        {
            name : "Meal delivery website using React",
            tags : ["react", "webpack", "immutable.js", "redux-thunk"],
            icon : Hellofresh_img,
            link : "https://www.hellofresh.com"
        },
        {
            name : "Pet sitting service website using React",
            tags : ["next.js", "google maps", "stripe", "lodash"],
            icon : Madpaws_img,
            link : "https://www.madpaws.com.au"
        },
        {
            name : "House rental portal website using React",
            tags : ["react", "redux-saga", "Sentry"],
            icon : Beroomers_img,
            link : "https://www.beroomers.com"
        },
        {
            name : "Website for kids investment using React",
            tags : ["gatsby", "amazon s3", "lodash"],
            icon : Loved_img,
            link : "https://www.loved.com"
        },
        {
            name : "E-commerce website using React",
            tags : ["react", "express", "lua", "node.js"],
            icon : Boutique_img,
            link : "https://leboutique.com"
        },
        {
            name : "A medical website using MERN stack",
            tags : ["react", "react-router", "react-icons", "nodemailer"],
            icon : Tourmed_img,
            link : "https://github.com/WillieRivera/MedicalTour"
        },
        {
            name : "A camera video analyzation Website using MEAN stack",
            tags : ["angularJS", "mongodb", "express"],
            icon : Motion_img,
            link : "https://github.com/WillieRivera/Angular-Motion"
        },
        {
            name : "A private property marketplace",
            tags : ["vue", "element-ui", "pdf.js", "webpack"],
            icon : HousePro_img,
            link : "https://houseproapp-test.herokuapp.com/"
        },
        {
            name : "A Hotel Management System using ASP.NET",
            tags : ["asp.net", "HMS", "redis"],
            icon : HMS_img,
            link : "https://github.com/WillieRivera/ASP.NET-HMS"
        },    
        {
            name : "An electronics marketplace",
            tags : ["laravel", "PHP 7"],
            icon : Cubizy_img,
            link : "https://cubizy.com"
        },
        {
            name : "A rental marketplace",
            tags : ["wordpress", "google-maps-api", "stripe", "tazworks"],
            icon : Tnant_img,
            link : ""
        },
        {
            name : "A car tracking admin dashboard developed with CakePHP",
            tags : ["CakePHP", "google-maps-api", "dashboard"],
            icon : CarTrack_img,
            link : "https://github.com/WillieRivera/CarTrackingSystem"
        },
        {
            name : "A responsive chat-app",
            tags : ["CSS3", "mobile-responsive", "react"],
            icon : ChatApp_img,
            link : "https://github.com/WillieRivera/Chat-App"
        },
        {
            name : "A chrome extension to autofill payment information",
            tags : ["Javascript", "Chrome-Extension"],
            icon : Autofill_img,
            link : "https://github.com/WillieRivera/Autofill_ChromeExtension"
        }

    ]

    const [styleDiv, setStyleDiv] = useState({display:'none'})
    const [styleLoading, setStyleLoading] = useState({display:'block'})
    const [loading, setLoading] = useState(true)
    

    useEffect(() => {
        const timer = setTimeout(() => {
            setStyleDiv({display:'block'})
            setStyleLoading({display:'none'})
            setLoading(false)
        }, 2000);
        return () => clearTimeout(timer);
    })
    

    return (
        <div id="projectsContainer" className="projectsContainer mainContainer">
            <ReactLoading className="loading_bar" type="spinningBubbles" color="#fff" style={styleLoading} />
            <div style={styleDiv}>
                <div className="searchbox">
                    <input type="text" className="SearchBar__searchInput__2b0RN" onChange={handleKeywordChange} placeholder="Search ...." value={keyword}/>
                </div>
                <div className="project_list">

                    {
                        projects.map(function(item,i){
                            return <ProjectCard key={i} className = "project_card"
                                                name = {item.name}
                                                tags = {item.tags}
                                                image = {item.icon}
                                                link = {item.link}
                                                search = {keyword}
                                                />
                        })
                    }

                </div>
            </div>
        </div>
    );

}